import { AttendanceStatusTypes, SubscriptionMethodTypes } from '../../domain/training.event.subscription';
import { EmailLogItemBasicArray } from '../../domain/email.log.item.basics';
import { TrainingEventSubscriptionCertificateResponseArray } from './training.event.subscription.certificate.response';
import { SortItem } from './member.dashboard.license.response';

export class TrainingHistoryResponse {
    Created_At: Date;
    Modified_At: Date;
    SignupDate: Date;
    TrainingEventSubscriptionID: Number;
    AlternateEmail: String;
    AlternatePhone: String;
    AttendanceStatusType: AttendanceStatusTypes;
    CertificatesAwarded: TrainingEventSubscriptionCertificateResponseArray;
    CreditsEarned: Number;
    LevelScoreEarned: Number;
    LicenseKey: String;
    License_ID: Number;
    ProductName: String;
    Product_ID: Number;
    SoftwareVersion: String;
    SubscriptionMethodType: SubscriptionMethodTypes;
    SubscriptionNotes: String;
    EmailLogs: EmailLogItemBasicArray;
    EventID: Number;
    EventDateTime: Date;
    TrainerID: Number;
    TrainingClassID: Number;
    ClassDuration: String;
    ClassName: String;
    ClassTitle: String;
    ClassProductIDs: number[];
    EventisDeleted: boolean;


    static FixDate(item: TrainingHistoryResponse) {
        item.Created_At = new Date(item.Created_At);
        item.Modified_At = new Date(item.Modified_At);
        item.SignupDate = new Date(item.SignupDate);
        item.EventDateTime = new Date(item.EventDateTime);
    }
}

export class TrainingHistoryResponseArray extends Array<TrainingHistoryResponse> {

    public LastSort = new SortItem();

    constructor(...items: TrainingHistoryResponse[]) {
        super(...items);
        Object.setPrototypeOf(this, TrainingHistoryResponseArray.prototype);
    }

    static FixDates(items: TrainingHistoryResponseArray) {
        items.forEach(x => TrainingHistoryResponse.FixDate(x));
    }

}
